import React from "react";
import * as Styles from "../../../../../../../../common-deprecated/styles/v2/toyota/custom/basket/Basket";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../../../redux/store";
import Icon from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { BnbLabel, getBnbLabel } from "../../../../../utils/labels";
import { showModal } from "../../../../../../../../common-deprecated/redux/actions/ModalActions";
import { MODAL_CONTENT } from "../../../../../../../../common-deprecated/utils/modalConstants";
import * as Type from "../../../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import { showExternalPriceTax } from "../../../../../utils/settings/bnbSettingUtils";
import SrOnly from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/ScreenreaderOnly";
import { useDispatch } from "../../../../../../../../shared-logic/redux/store";

const BasketHeader = (): JSX.Element => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const car = useBnbSelector((state) => state.car);
    const externalPrice = useBnbSelector((state) => state.externalPrice);
    const commonSettings = useBnbSelector((state) => state.commonSettings);
    const bnbSettings = useBnbSelector((state) => state.bnbSettings);
    const webtitleSectionNames = [
        car.model.webtitleSectionName,
        car.grade.webtitleSectionName,
        car.body.webtitleSectionName,
    ]
        .filter(Boolean)
        .join(", ");

    return (
        <>
            <Styles.CarTitle data-cpdqm="ignore">{webtitleSectionNames}</Styles.CarTitle>
            <Styles.CarDetails>
                <Type.SmallText>
                    <div>{car.motorization.engine.name}</div>
                    <div>
                        {car.motorization.transmission.name} ({car.motorization.wheeldrive.name})
                    </div>
                    {externalPrice.co2Specs.value && !showExternalPriceTax(bnbSettings) && (
                        <>
                            <div>
                                <BnbLabel
                                    label="co2Value"
                                    params={{ value: `${externalPrice.co2Specs.value} ${externalPrice.co2Specs.unit}` }}
                                />
                                &nbsp;
                                <a
                                    href="src/new-cars/original/buildandbuy/components/toyota/common/basket/content#"
                                    className="or-link or-has-icon"
                                    onClick={(event) => {
                                        event.preventDefault();
                                        dispatch(
                                            showModal({
                                                type: MODAL_CONTENT,
                                                content: getBnbLabel({ commonSettings, bnbSettings }, "co2Disclaimer"),
                                                useHTML: true,
                                            }),
                                        );
                                    }}
                                >
                                    <Icon variant="info" />
                                    <SrOnly>
                                        <BnbLabel label="bnbA11yButtonCo2SpecsDisclaimerOpen" />
                                    </SrOnly>
                                </a>
                            </div>
                        </>
                    )}
                </Type.SmallText>
            </Styles.CarDetails>
        </>
    );
};

export default BasketHeader;
